import PropTypes from 'prop-types'
import * as React from 'react'

import {themeable, forwardProps, createVariant} from '@base/react-utils'

import baseTheme from './Backdrop.css'

@themeable(baseTheme)
class Backdrop extends React.Component {
  static displayName = 'Backdrop'

  static propTypes = {
    fixed: PropTypes.bool,
    variant: PropTypes.oneOf([
      'transparent',
      'modal',
      'popover',
      'bottomPanel',
    ]),
    onClick: PropTypes.func,
  }

  static defaultProps = {
    fixed: true,
    variant: 'transparent',
  }

  render() {
    const theme = this.theme
    const {fixed, variant, onClick} = this.props

    return (
      <div
        {...forwardProps(this, {
          className: [
            theme.Backdrop,
            fixed && theme.fixed,
            variant && theme[`variant_${variant}`],
          ],
        })}
      >
        <div className={theme.background} onClick={onClick} />
        {this.props.children}
      </div>
    )
  }
}

export default Backdrop

export const ModalBackdrop = createVariant(Backdrop, {
  displayName: 'ModalBackdrop',
  defaultProps: {
    fixed: true,
    variant: 'modal',
  },
})

export const PopoverBackdrop = createVariant(Backdrop, {
  displayName: 'PopoverBackdrop',
  defaultProps: {
    fixed: true,
    variant: 'popover',
  },
})
